import { render, staticRenderFns } from "./WarehouseProductPeriodicStockTransactionsReport.vue?vue&type=template&id=3eff48d1&"
import script from "./WarehouseProductPeriodicStockTransactionsReport.vue?vue&type=script&lang=js&"
export * from "./WarehouseProductPeriodicStockTransactionsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports